import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { loginAdmin } from "../api/auth";
import logo from "../assets/logo.png";
import Navigation from "../components/navigation";

export default function AdminLogin() {
  const navigate  = useNavigate();
  const location  = useLocation();
  const [username, setUsername]     = useState("");
  const [password, setPassword]     = useState("");
  const [error,    setError]        = useState("");
  const [isSubmitting, setSubmitting] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await loginAdmin(username.trim(), password);
      navigate(location.state?.from || "/admin", { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <>
          <Navigation />

    <main style={s.page}>
      <section style={s.card} aria-labelledby="login-title">

        {/* Logo mark */}
        <div>
          <img src={logo} alt="My Car Kenya Logo" className="w-24" />
        
        </div>

        <h1 id="login-title" style={s.title}>Welcome Back</h1>
        <p style={s.subtitle}>Sign in for garage management and manage your inventory</p>

        <form onSubmit={handleSubmit} style={s.form} noValidate>

          {/* Username */}
          <div style={s.fieldWrap}>
            <span style={s.icon}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="1.7"/>
                <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/>
              </svg>
            </span>
            <input
              style={s.input}
              type="text"
              placeholder="Username"
              autoComplete="username"
              value={username}
              onChange={e => setUsername(e.target.value)}
              required
            />
          </div>

          {/* Password */}
          <div style={s.fieldWrap}>
            <span style={s.icon}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <rect x="5" y="11" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="1.7"/>
                <path d="M8 11V7a4 4 0 0 1 8 0v4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/>
                <circle cx="12" cy="16" r="1.5" fill="currentColor"/>
              </svg>
            </span>
            <input
              style={s.input}
              type="password"
              placeholder="Password"
              autoComplete="current-password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
          </div>

          {error && (
            <p style={s.error} role="alert">{error}</p>
          )}

          <button
            type="submit"
            style={{ ...s.btn, ...(isSubmitting ? s.btnDisabled : {}) }}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <p style={s.footer}>Authorized administrators only</p>
      </section>
    </main>
    </>
  );
}

// ── Inline styles ───────────────────────────────────────────────
const RED    = "#c1392a";
const BORDER = "#e2e8f0";
const MUTED  = "#94a3b8";
const TEXT   = "#1a1f2e";

const s = {
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "'Inter', -apple-system, sans-serif",
    padding: "13px",
  },
  card: {
    background: "#fff",
    borderRadius: 16,
    boxShadow: "0 4px 24px rgba(0,0,0,.07)",
    padding: "40px",
    width: "100%",
    maxWidth: 400,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 0,
  },
  logo: {
    width: 48,
    height: 48,
    borderRadius: 12,
    background: RED,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 24,
    flexShrink: 0,
  },
  title: {
    fontSize: 26,
    fontWeight: 700,
    color: TEXT,
    margin: "0 0 6px",
    textAlign: "center",
    letterSpacing: "-0.4px",
  },
  subtitle: {
    fontSize: 13,
    color: MUTED,
    margin: "0 0 32px",
    textAlign: "center",
  },
  form: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 14,
  },
  fieldWrap: {
    position: "relative",
    display: "flex",
    alignItems: "center",
  },
  icon: {
    position: "absolute",
    left: 14,
    color: MUTED,
    display: "flex",
    pointerEvents: "none",
  },
  input: {
    width: "100%",
    padding: "12px 14px 12px 42px",
    border: `1.5px solid ${BORDER}`,
    borderRadius: 10,
    fontSize: 14,
    color: TEXT,
    outline: "none",
    boxSizing: "border-box",
    fontFamily: "inherit",
    transition: "border-color .15s",
    background: "#fff",
  },
  error: {
    fontSize: 13,
    color: RED,
    margin: "0",
    padding: "10px 14px",
    background: "#fef2f2",
    borderRadius: 8,
    borderLeft: `3px solid ${RED}`,
  },
  btn: {
    width: "100%",
    padding: "13px",
    background: RED,
    color: "#fff",
    border: "none",
    borderRadius: 10,
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer",
    marginTop: 4,
    transition: "opacity .15s",
    fontFamily: "inherit",
    letterSpacing: "0.1px",
  },
  btnDisabled: {
    opacity: 0.65,
    cursor: "not-allowed",
  },
  footer: {
    fontSize: 11,
    color: MUTED,
    marginTop: 24,
    textAlign: "center",
  },
};